// import React, { useRef } from "react";
// import { motion, useInView } from "framer-motion";
// import FormatQuoteIcon from "@mui/icons-material/FormatQuote";

// const DirectorProfile = () => {
//   const ref = useRef(null);
//   const isInView = useInView(ref, { once: true, amount: 0.2 });

//   const containerVariants = {
//     hidden: { opacity: 0, y: 50 },
//     visible: {
//       opacity: 1,
//       y: 0,
//       transition: {
//         duration: 0.8,
//         ease: "easeOut",
//         when: "beforeChildren",
//         staggerChildren: 0.3,
//       },
//     },
//   };

//   const childVariants = {
//     hidden: { opacity: 0, y: 50 },
//     visible: {
//       opacity: 1,
//       y: 0,
//       transition: {
//         duration: 0.6,
//         ease: "easeOut",
//       },
//     },
//   };

//   return (
//     <div ref={ref} className="relative bg-[#2D3741]">
//       <div className="absolute left-0 right-0 bg-gradient-to-t -top-28 w-full min-h-28 z-20 from-[#2D3A45] to-transparent"></div>
//       <div className=" relative w-full z-10 ">
//         <motion.div
//           variants={containerVariants}
//           initial="hidden"
//           animate={isInView ? "visible" : "hidden"}
//           className="lg:bg-[#2D3741] bg-primary relative w-full md:w-[100%] flex flex-col md:flex-row items-center justify-between overflow-hidden"
//         >
//           <motion.div
//             variants={childVariants}
//             className="absolute top-32 hidden lg:block left-[35%] right-0"
//           >
//             <h4 className="text-white text-2xl font-normal">Director</h4>
//             <div className="border-b border-gray-600 mt-4 lg:w-[870px]"></div>
//           </motion.div>

//           <motion.div
//             variants={childVariants}
//             className="absolute top-6 lg:hidden left-14 right-8"
//           >
//             <h4 className="text-white text-lg md:text-xl font-normal">
//               Director
//             </h4>
//             <div className="border-b border-gray-600 mt-2"></div>
//           </motion.div>

//           <div className="flex flex-col md:flex-row items-center pb-10 lg:pb-0 px-4 sm:px-6 md:px-8 justify-around w-full pt-20 md:pt-10">
//             <motion.div
//               variants={childVariants}
//               className="w-full md:w-[45%] flex justify-center items-center px-4 sm:px-6 md:px-8"
//             >
//               <img
//                 src="/assets/image/director.png"
//                 alt="Sanjay Jain, Director"
//                 className="max-w-full h-auto sm:max-w-[70%] md:max-w-[80%] lg:max-w-full"
//               />
//             </motion.div>

//             <motion.div
//               variants={childVariants}
//               className="lg:bg-[#AB052D] bg-[#AB052D] text-white rounded-xl p-6 sm:p-8 w-full md:mt-10 md:w-[500px] md:h-[441px] lg:w-1/2 max-w-[570px]  md:mr-4"
//             >
//               <h3
//                 className="text-[40px] sm:text-[45px] md:text-[50px] font-medium  relative pt-4
//                 before:content-[''] before:absolute before:top-0 before:left-0
//                 before:w-20 before:h-0.5 before:bg-white"
//               >
//                 Sanjay Jain
//               </h3>
//               <p className="text-sm md:text-md lg:text-lg opacity-90 ">
//                 B.E. Mechanical Engineering
//               </p>
//               <p className="text-sm md:text-md lg:text-lg opacity-90 ">
//                 35 years Experience
//               </p>

//               <div className="flex mt-8 md:mt-11 mb-8 md:mb-12">
//                 <FormatQuoteIcon className="!w-12 !h-12 text-white rotate-180 opacity-80 " />

//                 <p className="text-sm md:text-lg lg:text-[22px] mt-3 leading-tight">
//                   To be the premier Hydraulic Systems integrator and service
//                   provider, driving industrial evolution through innovative
//                   solutions, precision engineering, and a commitment to
//                   providing unparalleled services worldwide.
//                 </p>
//               </div>
//             </motion.div>
//           </div>
//         </motion.div>
//       </div>
//     </div>
//   );
// };

// export default DirectorProfile;

import React from "react";
import { motion, Variants } from "framer-motion";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import {globalTransition} from "../../../assets/animate/globalAnimation"


const DirectorProfile = () => {
  // Define variants matching the sample component
  const containerVariants: Variants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3, // Matches sample component
        ...globalTransition,
        
      },
    },
  };

  const childVariants: Variants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        ...globalTransition, // Matches sample
        ease: "easeOut", // Matches sample
      },
    },
  };

  return (
    <div id="leadership-section" className="relative bg-[#2D3741]">
      <div className="absolute left-0 right-0 bg-gradient-to-t -top-28 w-full min-h-28 z-20 from-[#2D3741] to-transparent"></div>
      <div className="relative w-full z-10">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }} // Trigger when 10% is in view, like sample
          className="lg:bg-[#2D3741] bg-primary relative w-full md:w-[100%] flex flex-col md:flex-row items-center justify-between overflow-hidden"
        >
          <motion.div
            variants={childVariants}
            className="absolute top-32 hidden lg:block left-[35%] right-0"
          >
            <h4 className="text-white text-2xl font-normal">Director</h4>
            <div className="border-b border-gray-600 mt-4 lg:w-[870px]"></div>
          </motion.div>

          <motion.div
            variants={childVariants}
            className="absolute top-6 lg:hidden left-14 right-8"
          >
            <h4 className="text-white text-lg md:text-xl font-normal">
              Director
            </h4>
            <div className="border-b border-gray-600 mt-2"></div>
          </motion.div>

          <div className="flex flex-col md:flex-row items-center pb-10 lg:pb-0 px-4 sm:px-6 md:px-8 justify-around w-full pt-20 md:pt-10">
            <motion.div
              variants={childVariants}
              className="w-full md:w-[45%] flex justify-center items-center px-4 sm:px-6 md:px-8"
            >
              <img
                src="/assets/image/director.png"
                alt="Sanjay Jain, Director"
                className="max-w-full h-auto sm:max-w-[70%] md:max-w-[80%] lg:max-w-full"
              />
            </motion.div>

            <motion.div
              variants={childVariants}
              className="lg:bg-[#AB052D] bg-[#AB052D] text-white rounded-xl p-6 sm:p-8 w-full md:mt-10 md:w-[500px] md:h-[500px] lg:w-1/2 max-w-[570px] md:mr-4"
            >
              <h3
                className="text-[40px] sm:text-[45px] md:text-[50px] font-medium relative pt-4
                before:content-[''] before:absolute before:top-0 before:left-0
                before:w-20 before:h-0.5 before:bg-white"
              >
                Sanjay Jain
              </h3>
              <p className="text-sm md:text-md lg:text-lg opacity-90">
                B.E. Mechanical Engineering
              </p>
              <p className="text-sm md:text-md lg:text-lg opacity-90">
                35 years Experience
              </p>

              <div className="flex mt-8 md:mt-11 mb-8 md:mb-12">
                <FormatQuoteIcon className="!w-12 !h-12 text-white rotate-180 opacity-80" />

                <p className="text-sm md:text-lg lg:text-[22px] mt-3 leading-tight">
                With 35 years of experience in the hydraulic industry, I understand that oil cleanliness is the leading factor in hydraulic system failures. At Siskon Ventures Pvt LTD, we prioritize advanced filtration and monitoring solutions to ensure optimal system performance, longevity, and reliability.
                </p>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default DirectorProfile;
